// src/components/ci/Brand.tsx

import { Box } from '@mui/material'
import { Link } from 'react-router-dom'

import { svgConstants as SVG } from '../../constants'

type Props = {
  collapsed?: boolean
  width?: number
}

export const Brand = ({ collapsed = false, width = 35 }: Props) => (
  <Box
    sx={{
      py: '20px',
      px: 2,
      position: 'relative',
      zIndex: 4,
      display: 'flex',
      alignItems: 'center',
      justifyContent: collapsed ? 'center' : 'flex-start',

      '&:after': {
        backgroundColor: 'hsla(0,0%,100%,.3)',
        bottom: 0,
        content: '""',
        height: '1px',
        position: 'absolute',
        right: '15px',
        width: 'calc(100% - 30px)',
      },
    }}
  >
    <Link
      to={'/'}
      style={{
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        gap: collapsed ? 0 : 12,
      }}
    >
      <Box
        component={'img'}
        src={SVG.KARMA_LOGO}
        alt={'KARMA Logo'}
        sx={{
          width,
          display: 'block',
        }}
      />

      {!collapsed && (
        <Box
          sx={{
            color: 'white',
            fontSize: 18,
          }}
        >
          KARMA
        </Box>
      )}
    </Link>
  </Box>
)
